export default __webpack_public_path__ + "static/nick-140933102345c4b2f3b1402daf983a63.jpg";